export default function GradientHeading({ children, className = "" }) {
  return (
    <h2
      className={`font-bold bg-brand-gradient bg-clip-text text-transparent text-[32px] min-[478px]:text-[38px] md:text-[40px] xl:text-[60px] leading-[1.1] ${className}`}
    >
      {children}
    </h2>
  );
}
